import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { io } from 'socket.io-client';
import { isMessageId } from '../services/learnerMessages';

export const MESSAGING_REFRESH_EVENT = 'hauraki:messaging-refresh';

/** A wakeup is not message content or authorization. Consumers refetch HTTP. */
export function useMessagingWakeups(): void {
  const auth = useAuth();
  const subject = auth.isAuthenticated ? auth.user?.profile.sub : undefined;
  const token = auth.isAuthenticated ? auth.user?.access_token : undefined;
  useEffect(() => {
    if (!subject || !token) return;
    let active = true;
    const socket = io(process.env.REACT_APP_WS_URL || process.env.REACT_APP_API_URL || window.location.origin, {
      path: '/socket.io', auth: { token }, transports: ['websocket'], forceNew: true,
      reconnection: true, reconnectionDelay: 1_000, reconnectionDelayMax: 30_000,
    });
    const refresh = () => { if (active) window.dispatchEvent(new Event(MESSAGING_REFRESH_EVENT)); };
    const messageChanged = (payload: unknown) => {
      if (payload && typeof payload === 'object' && isMessageId((payload as { threadId?: unknown }).threadId)) refresh();
    };
    socket.on('connect', refresh);
    socket.on('message:changed', messageChanged);
    socket.on('notification:new', refresh);
    // Polling remains the durable fallback while disconnected. Never log a token
    // or promote a provider event into a trusted transcript/permission decision.
    return () => {
      active = false;
      socket.off('connect', refresh);
      socket.off('message:changed', messageChanged);
      socket.off('notification:new', refresh);
      socket.disconnect();
    };
  }, [subject, token]);
}
